
import React from "react";
import Slider from "react-slick";
import moment from 'moment';
import NewsImage from "../NewsImage";
import Link from "next/link";

const NewsCarrousel = ({ newsData }) => {
  const slider_setting = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,

    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 765,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          rows: 2
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  };

  return (
    <>
      <div className="container box--wrap marg heading-container merchandise-space">
        <h2 className="A-la-venta-esta-sema ">Latest News</h2>
        <div className="line4"></div>
      </div>
      <div className="container-fluid">
        <section className={`regular news_image_slider`}>
          <div className="news_slider_wrapper">
            <Slider {...slider_setting}>
              {
                newsData?.map((item, i) => (
                  <Link passHref={true} key={`noticia${i}`} href={`/foreign-rights/content/${item.slug}`}>
                    <a className="contentLinks" target={item.newWindow == 1 ? '_blank' : '_self'}>
                      <div className="noticias">
                        <div className="news_image_slider_img">
                          <NewsImage imagesrc={item.image} />
                        </div>
                        <div className="connoticias">
                          	<h1>{item?.title}</h1>
                          	<div className="news_description" dangerouslySetInnerHTML={{ __html: item?.shortContent }} ></div>
							<div>{moment(item?.publicationDate).format('DD/MM/YYYY')}</div>
                      
                        </div>
                      </div>
                    </a>
                  </Link>
                ))
              }
            </Slider>
          </div>
        </section>
      </div>
    </>
  );
}

export default NewsCarrousel;
